const transformTotals = ({ coupon_code , coupon_label , discount_amount , gift_cards , gift_cards_informations , gift_option_final_price , grand_total , base_grand_total , msp_cod , reward_currency_amount , reward_points_balance , shipping_incl_tax , subtotal_incl_tax , tax_amount  })=>({
        grandTotal: parseFloat(grand_total),
        baseGrandTotal: parseFloat(base_grand_total),
        discount: parseFloat(discount_amount),
        tax: parseFloat(tax_amount),
        subtotal: parseFloat(subtotal_incl_tax),
        shipping: parseFloat(shipping_incl_tax),
        cashOnDelivery: msp_cod ?? null,
        giftCards: gift_cards ?? null,
        giftCardsInformation: gift_cards_informations?.length ? gift_cards_informations?.map(({ c: code , ba: balance /* , i: id, a: amount */   })=>({
                code,
                usedAmount: balance
            })) : null,
        giftWrap: gift_option_final_price ?? null,
        rewardPointsBalance: reward_points_balance ?? null,
        rewardPointsCurrency: reward_currency_amount ?? null,
        couponLabel: coupon_label ?? null,
        couponCode: coupon_code ?? null
    });

export { transformTotals };
